<script>
	import MenuItem from "../FlyoutMenu/MenuItem.svelte";
	import "./KeyComponent.scss";
	import Radio from '@smui/radio';
	import FormField from '@smui/form-field';

	import AlertsStore from "../../Alerts/Store";
	import AlertType from "../../Alerts/AlertType";
	import IconMode from "../../Map/Enums/IconMode";
	import IconModeDescription from "../../Map/Enums/IconModeDescription";
	import KeyColors from "./KeyColors.svelte";
	import { writable } from "svelte/store";
	
	export let title = "Icons";
	export let mode = writable(IconMode.ALERT);// AlertsStore.iconMode;
	export let iconType = "vessel";
	export let availableModes = [];

	const toggleIconMode = e => {
		$mode = e.target.value;
	};


	export let defaultModeName = "Alert Type";
	export let disabled = false;
</script>

<MenuItem title={title} materialIcon={"info"} class="key-component">
	<div style="margin-bottom:10px">
		{#each availableModes as availableMode}
			<FormField>
				<Radio on:click={toggleIconMode} bind:group={$mode} value={availableMode} disabled={disabled}/>
				<span slot="label">
					{#if availableMode === IconMode.ALERT}
						{defaultModeName}
					{:else}
						{IconModeDescription[availableMode]}
					{/if}
				</span>
			</FormField>
		{/each}

		<!-- <FormField>
			<Radio on:click={toggleIconMode} bind:group={$mode} value={IconMode.ALERT} disabled={disabled}/>
			<span slot="label">{defaultModeName}</span>
		</FormField>
		<FormField>
			<Radio on:click={toggleIconMode} bind:group={$mode} value={IconMode.TIME_DIFFERENCE} disabled={disabled}/>
			<span slot="label">Time Difference</span>
		</FormField>
		
		<FormField>
			<Radio on:click={toggleIconMode} bind:group={$mode} value={IconMode.SPEED} disabled={disabled}/>
			<span slot="label">Speed</span>
		</FormField>
		<FormField>
			<Radio on:click={toggleIconMode} bind:group={$mode} value={IconMode.VESSEL_TYPE} disabled={disabled}/>
			<span slot="label">Vessel Type</span>
		</FormField>
		<FormField>
			<Radio on:click={toggleIconMode} bind:group={$mode} value={IconMode.INDEX} disabled={disabled}/>
			<span slot="label">Index / Sequence</span>
		</FormField>
		{#if $hasRimKey}
			<FormField>
				<Radio on:click={toggleIconMode} bind:group={$mode} value={IconMode.RISK_LEVEL} disabled={disabled}/>
				<span slot="label">Risk Level (RIM)</span>
			</FormField>
		{/if} -->
		<!-- <FormField>
			<Radio on:click={toggleIconMode} bind:group={$mode} value={IconMode.TIME_SINCE_PREVIOUS_UPDATE} />
			<span slot="label">Time Since Update / Previous Update</span>
		</FormField> -->
	</div>

	<div class="content">
		<KeyColors iconMode={$mode} iconType={iconType} defaultModeName={defaultModeName} />
	</div>

</MenuItem>
